/**
 * @generated SignedSource<<8f81217caadfe6553d210e260de4b7fb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceSelectorContent_workspaces$data = ReadonlyArray<{
  readonly id: string;
  readonly name: string;
  readonly parentId: string | null;
  readonly " $fragmentType": "WorkspaceSelectorContent_workspaces";
}>;
export type WorkspaceSelectorContent_workspaces$key = ReadonlyArray<{
  readonly " $data"?: WorkspaceSelectorContent_workspaces$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceSelectorContent_workspaces">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "WorkspaceSelectorContent_workspaces",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "parentId",
      "storageKey": null
    }
  ],
  "type": "Workspace",
  "abstractKey": null
};

(node as any).hash = "8e6f4806e37132dbf67758b68bdc3961";

export default node;
